// src/components/ChatHistory.jsx

import React, { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import languageContext from "../context/language/languageContext";
import Navbar from "./Navbar"; // Ensure Navbar is customized for Warden

const ChatHistory = () => {
  const location = useLocation();
  const { setSessionTimeout, setAlert, setMessage } = useContext(languageContext);
  const [messages, setMessages] = useState([]);

  const chat_history_student = async () => {
    const student_id = location.state?.patient_id; // or use student_id if renamed
    if (!student_id) return;

    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/doctor_chat_history",
        JSON.stringify({ id: student_id }),
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setMessages(response.data.chat_history);
      }
    } catch (error) {
      if (error.response?.data?.detail === "Token has expired") {
        setSessionTimeout(true);
      } else {
        setAlert(true);
        setMessage("Something went wrong. Please try again later.");
        console.error("Chat History Fetch Error:", error.message);
      }
    }
  };

  useEffect(() => {
    chat_history_student();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-white">
      <Navbar />

      <div className="max-w-6xl mx-auto px-4 sm:px-8 pt-24">
        <h2 className="text-4xl font-bold text-indigo-800 text-center mb-10 tracking-tight">
          🧑‍🎓 Warden Portal – Student Interaction History
        </h2>

        {messages.length === 0 ? (
          <div className="text-center text-gray-500 italic py-20 text-lg">
            No interaction records found.
          </div>
        ) : (
          <div className="space-y-6 pb-16">
            {messages.map((msg) => (
              <div
                key={msg.id}
                className="bg-white border border-indigo-100 rounded-2xl shadow-md p-6 transition hover:shadow-lg"
              >
                <div className="flex justify-between text-xs text-gray-400 mb-3">
                  <span>{new Date(msg.timestamp).toLocaleString()}</span>
                  <span className="bg-indigo-100 text-indigo-700 px-3 py-0.5 rounded-full font-medium">
                    ID: {msg.id}
                  </span>
                </div>

                <div className="mb-3">
                  <p className="text-base sm:text-lg">
                    <span className="font-semibold text-indigo-700">Student:</span>{" "}
                    {msg.user_question || (
                      <em className="text-gray-400">[No Question]</em>
                    )}
                  </p>
                </div>

                <div>
                  <p className="text-base sm:text-lg">
                    <span className="font-semibold text-emerald-600">Assistant:</span>{" "}
                    {msg.bot_response || (
                      <em className="text-gray-400">[No Response]</em>
                    )}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatHistory;
